import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { brandColors } from '../theme';

const HomePage: React.FC = () => {
  return (
    <Box sx={{ backgroundColor: brandColors.white }}>
      {/* HERO SECTION */}
      <Container maxWidth="lg" sx={{ pt: 8, pb: 6 }}>
        <Grid container spacing={4} alignItems="flex-start">
          {/* Left: Heading & Intro */}
          <Grid item xs={12} md={6}>
            <Typography
              component="h1"
              sx={{
                color: brandColors.blue,
                fontWeight: 400,
                fontSize: { xs: '2.25rem', sm: '2.75rem', md: '3.25rem' },
                lineHeight: 1.05,
                letterSpacing: '-0.5px',
                mb: 2,
              }}
            >
              Horwath HTL Licensee Portal
            </Typography>
            <Typography
              variant="h4"
              sx={{
                color: brandColors.indigo,
                fontWeight: 500,
                fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
                mb: 4,
              }}
            >
              Manage Your Markets and Business Operations in One Place
            </Typography>
            <Typography variant="body1" sx={{ color: brandColors.mediumGray, lineHeight: 1.8 }}>
              This portal is exclusively for Horwath HTL Licensees and provides capabilities including managing market details that appear on the HTL MarketCompass site, creating and managing Horwath HTL branded invoices for your customers with real-time status tracking, and many additional features coming in the future.
            </Typography>
          </Grid>
          {/* Right: Angled image placeholder (hide below md to avoid overlap when nav collapses) */}
          <Grid item xs={12} md={6} sx={{ display: { xs: 'none', md: 'block' } }}>
            <Box
              sx={{
                height: { xs: 416, md: 728 },
                backgroundImage: 'url(/images/home-page-image.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'right top',
                backgroundRepeat: 'no-repeat',
                // Create a triangle with a pointed apex at the top, similar to the reference
                clipPath: 'polygon(60% 0, 100% 85%, 0 100%)',
                mt: -25,
                // Make the triangle flow off the right edge of the page
                width: { xs: '120%', md: '140%' },
                ml: 'auto',
                mr: { xs: '-10vw', md: '-12vw' },
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HomePage;